export const SUPPORTED_LANGUAGES = ['de', 'en']
export const DEFAULT_LANGUAGE = 'en'

const STORAGE_KEY = 'claimform_state'

const normalize = (lang) => lang?.slice(0, 2).toLowerCase()

// First supported language from the browser preferences (navigator.languages), else default
export function detectBrowserLanguage() {
  try {
    const preferred = [...(navigator.languages || []), navigator.language]
    const match = preferred.map(normalize).find((lang) => SUPPORTED_LANGUAGES.includes(lang))
    return match || DEFAULT_LANGUAGE
  } catch {
    return DEFAULT_LANGUAGE
  }
}

// Language explicitly chosen in the app (persisted in claimform state) wins over the browser setting
export function getInitialLanguage() {
  try {
    const saved = normalize(JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}').language)
    if (SUPPORTED_LANGUAGES.includes(saved)) return saved
  } catch {
    // ignore storage errors (e.g. private mode)
  }
  return detectBrowserLanguage()
}
